import { render, staticRenderFns } from "./afterSalesDocumentDetail.vue?vue&type=template&id=8c7d3092&scoped=true"
import script from "./afterSalesDocumentDetail.vue?vue&type=script&lang=js"
export * from "./afterSalesDocumentDetail.vue?vue&type=script&lang=js"
import style0 from "./afterSalesDocumentDetail.vue?vue&type=style&index=0&id=8c7d3092&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7d3092",
  null
  
)

export default component.exports